import React from 'react';
import { Col, Row, ListGroupItem} from 'reactstrap';
import { SortableElement } from 'react-sortable-hoc';
import MaterialIcon from 'material-icons-react';

export const SortableMenuItem = SortableElement(({item, activeItem, onSelect, restaurantId, renderActionComponent, disabled, column, styles}) => {
    const {
        listGroupItem, editStyle, cursorPointer, rowMarginRight,
        activeStyle, activeNotPublished,
        selectedItem, selectedItemItalics,
        inactiveStyle, inactiveStyleItalics } = styles;

    const listGroupItemStyle = activeItem.id === item.id ? activeStyle : listGroupItem;
    const itemStyle = !item.active ?
        (activeItem.id === item.id ?
            (!item.published ? selectedItemItalics : selectedItem):
            (!item.published ? inactiveStyleItalics : inactiveStyle)
        ) :
        !item.published ? activeNotPublished : cursorPointer ;

    let doesNotHaveDependsOnQuestion = true;

    if(item.dependsOnQuestionId !== undefined && item.dependsOnQuestionId !== null && item.dependsOnQuestionId !== -1) {
        doesNotHaveDependsOnQuestion = false;
	}

    return (
    	<ListGroupItem id={`${column}-list-item-${item.id}`} style={listGroupItemStyle} >
    		<Row style={rowMarginRight}>
    			<Col sm={!renderActionComponent ? 12 : 9} id={`${column}-list-item-${item.id}-inner`} onClick={() => onSelect(item, column)} style={{...itemStyle, display: 'flex'}}>
    				<div className="longerNamesStyle">{item.sizeName} {item.name}</div>
                    <span hidden={doesNotHaveDependsOnQuestion} className="dependsOnIcon"><MaterialIcon icon="link" /></span>
				</Col>
                { 
                    !renderActionComponent ? null :
                    <Col sm={3} className='text-center' >{renderActionComponent(item, column, restaurantId)}</Col>
                }
    		</Row>
    	</ListGroupItem>
    );
});


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/SortableMenuItem.js